import axios from "axios";
import { useMutation } from "@tanstack/react-query";

import { Keys } from "clients/apis/_keys";
import { Routes } from "clients/apis/_routes";

import { onEditReminderRes } from "./helper";

export const editReminder = async (params: {
  id: number;
  data: EditReminderReqT;
}) => axios.put(Routes.EDIT_REMINDER + "/" + params.id, { ...params.data });

export const useEditReminder = () =>
  useMutation({
    mutationKey: [Keys.EDIT_REMINDER_MUT],
    mutationFn: editReminder,
    onSuccess: (res) => {
      onEditReminderRes(res);
      return res;
    },
  });
